export default function SectionHeading({ title, subtitle, href, actionLabel = "View all ->" }) {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mt-12 mb-6">
      <div className="flex items-end justify-between">
        <div>
          <h2 className="text-xl font-bold md:text-2xl">{title}</h2>
          {subtitle ? <p className="mt-1 text-sm text-slate-600">{subtitle}</p> : null}
        </div>
        {href ? (
          <a href={href} className="text-sm font-semibold">
            {actionLabel}
          </a>
        ) : null}
      </div>
    </div>
  );
}